<template>
    <fade-in-component>
      <section class="job-section">
        <div class="jsinner">
          <h2 class="ttlbar _mb40">{{ttl}}のセールスパーソン特徴</h2>
          <div class="salesperson-feature">
            <div class="block -left">
              <div class="txtbln _trgbtmct">
                <p class="subtxt">人物特性</p>
                <p class="maintxt"><slot name="feature"></slot></p>
              </div>
              <p class="imgcv"><slot name="imgpup"></slot></p>
            </div>
            <div class="block -right">
              <SevenChart :sevenData="data"></SevenChart>
            </div>
          </div><!-- salesperson-feature -->
        </div><!-- .jsinner -->
      </section>
    </fade-in-component>
</template>

<script>
import SevenChart from "../components/SevenChart.vue";
import FadeInComponent from "../components/FadeInComponent.vue";

export default {
  props: ["sevenData", "explain", "secTtl"],
  components: {
    SevenChart,
    FadeInComponent,
  },
  data() {
    return {
      secExplain: this.explain,
      data: this.sevenData,
      ttl: this.secTtl
    };
  },
};
</script>